import { useState } from 'react';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { getLifebooksChild } from 'redux/selectors';
import { useCheckUserPermissions } from 'helpers/hooks';
import ExportPdfButton from './ExportPdfButton';
import ExportPdfForm from './ExportPdfForm';
import styles from '../ChildAdmin.module.css';

export default function ExportPdf(props) {
	const child = useSelector(getLifebooksChild);
	const { childId } = useParams();
	const [open, setOpen] = useState(false);
	const openProps = { open, setOpen };
	const { includeUsers } = useCheckUserPermissions();

	let info;
	let label;

	if (props.type === 'pdf') {
		info = child.privatizePosts
			? 'Request approval from child to export LifeBook'
			: "Use this option to export a copy of this child's LifeBook.";

		label = child.privatizePosts
			? 'Request LifeBook Export'
			: 'Export LifeBook (pdf)';
	} else if (props.type === 'zip') {
		info = child.privatizePosts
			? 'Request approval from child to export Photos'
			: "Use this option to export a copy of this child's photos.";
		label = child.privatizePosts
			? 'Request Photos Export'
			: 'Export Photos (zip)';
	}

	const isAllowed =
		childId && includeUsers('manager', 'admin', 'social-worker', 'casauser');

	return isAllowed ? (
		<>
			<div className={styles.childAdminItemWrapper}>
				<div>
					<div className={styles.childAdminBoldLabel}>{label}</div>
					<div>{info}</div>
				</div>
				<div className={styles.childAdminButtonContainer}>
					{!open && (
						<ExportPdfButton
							{...openProps}
							privatized={child?.privatizePosts}
						/>
					)}
				</div>
			</div>
			{open && <ExportPdfForm {...openProps} type={props.type} />}
		</>
	) : null;
}
